// import { create } from "zustand";

// export const useLoaderStore = create((set) => ({
//     loading: false,
//     restoringSession: true,

//     showLoader: () =>
//         set({ loading: true }),

//     hideLoader: () =>
//         set({ loading: false }),

//     startRestore: () => set({ restoringSession: true }),
//   finishRestore: () => set({ restoringSession: false }),
// }));


import { create } from "zustand";

export const useLoaderStore = create((set) => ({
    loading: false,
    loaderType: "mobile",

    restoringSession: true,

    showLoader: (type = "mobile") =>
        set({
            loading: true,
            loaderType: type,
        }),

    hideLoader: () =>
        set({
            loading: false,
        }),

    startRestore: () =>
        set({
            restoringSession: true,
        }),

    finishRestore: () =>
        set({
            restoringSession: false,
        }),
}));